export const modelName = 'game';
export const FETCH_DATA_SUCCESS = '@game/FETCH_DATA_SUCCESS';
export const FETCH_STATUSES_SUCCESS = '@game/FETCH_STATUSES_SUCCESS';
export const FETCH_FAILED = '@game/FETCH_FAILED';
